<template>
  <kst-section items-mode>
    <kst-table view-mode :data="items">
      <b-table-column
        v-slot="{ column, row }"
        field="Name"
        :label="DeliveryItemCatalog.Name.Label"
      >
        <kst-value ellipsis :field="column.field" :data="row" :catalog="DeliveryItemCatalog"/>
      </b-table-column>

      <b-table-column cell-class="ks-col-nopad" header-class="p-0" width="1">
        <template #header>
          <kst-header-blank />
        </template>
        <template #default="{ row }">
          <kst-tooltip info-mode>
            <template #content>
              <kst-list info-mode :items="Model.getItemInfo_Edit(row)"/>
            </template>
            <kst-icon info-mode/>
          </kst-tooltip>
        </template>
      </b-table-column>

      <b-table-column
        v-slot="{ column, row }"
        cell-class="ks-col-packaging"
        field="Packaging"
        :label="DeliveryItemCatalog.Packaging.Label"
      >
        <kst-value ellipsis :field="column.field" :data="row" :catalog="DeliveryItemCatalog"/>
      </b-table-column>

      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-qty"
        field="Quantity"
        :label="DeliveryItemCatalog.Quantity.Label"
      >
        <kst-value ellipsis :field="column.field" :data="row" :catalog="DeliveryItemCatalog"/>
      </b-table-column>

      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-subtotal"
        field="Weight"
        :label="DeliveryItemCatalog.Weight.Label"
      >
        <kst-value ellipsis :field="column.field" :data="row" :catalog="DeliveryItemCatalog"/>
      </b-table-column>
    </kst-table>
  </kst-section>
</template>

<script>
import DeliveryItemCatalog from "../DeliveryItemCatalog.js";
import Model from "../DeliveryModel.js";

export default {
  props: {
    items: Array
  },
  data: () => ({
    DeliveryItemCatalog: DeliveryItemCatalog,
    Model: Model
  })
}
</script>